import script from "./router-link-conditional.vue?vue&type=script&lang=ts"
export * from "./router-link-conditional.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__